import { CounterpartyIdAndAlias } from 'api'
import { defaultPrimeBrokerIdGetterSelector } from 'selectors'
import { preparedStagingOrdersSelector } from 'selectors/selectionSelectors'
import { PreparedStagingOrder } from 'store/selection/selectionTypes'
import { SelectionActions } from 'store/selection'
import { AppThunk } from 'utils'
import { IsAxedDefault, TradeConditionFlagDefault } from 'model'

const changeCounterpartyIds = (counterpartyIdsAndAliases: CounterpartyIdAndAlias[]): AppThunk => (dispatch, getState) => {
  const state = getState()

  const ordersToPrepare = preparedStagingOrdersSelector(state)
  const getDefaultPrimeBrokerId = defaultPrimeBrokerIdGetterSelector(state)

  const newPreparedStagingOrders = ordersToPrepare.map<PreparedStagingOrder>(orderToPrepare => {
    const {
      negotiationInstruction,
      orderDetail: {
        order: { fundId, primeBrokerId }
      }
    } = orderToPrepare
    const counterpartyInstructions = counterpartyIdsAndAliases.map(({ counterpartyId, counterpartyAlias }) => {
      const existing = negotiationInstruction.counterpartyInstructions.find(instruction => {
        if (counterpartyAlias) {
          return instruction.counterpartyId === counterpartyId && counterpartyAlias === instruction.counterpartyAlias
        }

        return instruction.counterpartyId === counterpartyId
      })

      return existing
        ? existing
        : {
            counterpartyId,
            tradeConditionFlag: TradeConditionFlagDefault,
            counterpartyAlias,
            axeId: null,
            internalAxeId: null,
            isAxed: IsAxedDefault,
            primeBrokerId: (fundId && getDefaultPrimeBrokerId(fundId, counterpartyId)) ?? primeBrokerId,

            // Below get defaulted at point of send
            repoType: null,
            masterLegalAgreementType: null
          }
    })

    return {
      ...orderToPrepare,
      negotiationInstruction: {
        ...orderToPrepare.negotiationInstruction,
        counterpartyInstructions
      }
    }
  })

  dispatch(SelectionActions.setPreparedStagingOrders(newPreparedStagingOrders))
}

export const RfqPanelThunks = {
  changeCounterpartyIds
}
